import { render, staticRenderFns } from "./avatar-index.vue?vue&type=template&id=611f8341&"
import script from "./avatar-index.vue?vue&type=script&lang=js&"
export * from "./avatar-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../resource-manage/node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports